import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import LeftMenu from "../components/LeftMenu";
import Breadcrumbs from "../components/Breadcrumbs";
import OrganizationRenameCard from "../features/organization/components/OrganizationRenameCard";
import OrganizationVocabularyCard from "../features/organization/components/OrganizationVocabularyCard";
import CancellationPolicyCard from "../features/organization/components/CancellationPolicyCard";
import FahrschulePresetCard from "../features/organization/components/FahrschulePresetCard";
import SampleDataCard from "../features/sample-data/components/SampleDataCard";
import BusinessDetailsSection from "../features/business-profile/components/BusinessDetailsSection";
import KeptTrainingRecordsCard from "../features/training/components/KeptTrainingRecordsCard";
import OrganizationRosterSection from "../features/organization/components/OrganizationRosterSection";
import OrganizationInvitationsSection from "../features/organization/components/OrganizationInvitationsSection";
import {
  selectOrganization,
} from "../features/organization/organization-slice";
import {
  fetchCurrentOrganization,
  fetchPendingInvitations,
} from "../features/organization/slice-extensions/organization-slice-extension";
import { fetchColleagues } from "../features/instructors/slice-extensions/instructors-slice-extension";

/**
 * Organization settings: rename, roster (roles / activation / ownership) and
 * instructor invitations. Reachable by Owner/Admin only (RequireOrgAdmin).
 */
const OrganizationSettingsPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const organization = useAppSelector(selectOrganization);

  useEffect(() => {
    dispatch(fetchCurrentOrganization());
    dispatch(fetchColleagues());
  }, [dispatch]);

  useEffect(() => {
    if (organization) {
      dispatch(fetchPendingInvitations({ organizationId: organization.id }));
    }
  }, [dispatch, organization]);

  return (
    <div className="flex h-full gap-4">
      <LeftMenu />
      <div className="w-full min-w-0 p-4 pb-10 lg:px-10">
        <div className="lg:max-w-[960px]">
          <Breadcrumbs />
          <div className="py-6">
            <h1>{t("settings.organization")}</h1>
            <div className="mt-4 space-y-4 lg:mt-6 lg:space-y-6">
              <OrganizationRenameCard />
              <OrganizationVocabularyCard />
              <FahrschulePresetCard />
              <CancellationPolicyCard />
              <SampleDataCard />
              <BusinessDetailsSection />
              <KeptTrainingRecordsCard />
              <OrganizationRosterSection />
              <OrganizationInvitationsSection />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganizationSettingsPage;
